import type { FC } from "react";

import { DebouncedTextInput } from "../../../../../common-ui/form-fields/DebouncedTextInput";
import { MAX_LENGTH_TRAILER_REG } from "../../../../../common/fieldLengths";
import { useUpdateRegistrationNumberAlert } from "../../../../../common/registrationNumberAlert/hooks/useUpdateRegistrationNumberAlert";
import { useUpdateField } from "../../../../../common/update-information/hooks/useUpdateField";
import { formatRegistrationNumberString } from "../../../../../common/utils/stringUtil";
import { TravelledVehicleType } from "../../../../../services/update-form/registrationNumberAlert";
import type { BookingFormState } from "../../../../../services/update-form/updateFormReducer";
import {
  transformUpdateFieldToTrackerAction,
  useTrackingTextInput,
} from "../../../../simple-create/hooks/UseTrackingTextInput";

interface RegistrationNoFieldProps {
  disabled: boolean;
  id?: string;
  type: keyof Pick<BookingFormState, "vehicleRegNo" | "trailerRegNo">;
}

export const RegistrationNoField: FC<RegistrationNoFieldProps> = ({
  disabled,
  id,
  type,
}) => {
  const { icon } = useUpdateRegistrationNumberAlert(
    "Details",
    type === "vehicleRegNo" ? "VehicleReg" : "TrailerReg",
    type === "vehicleRegNo"
      ? TravelledVehicleType.Vehicle
      : TravelledVehicleType.Trailer,
  );

  const { editedValue, onChange, initialValue } =
    useUpdateField<typeof type>(type);
  const { onBlur, onFocus } = useTrackingTextInput(
    transformUpdateFieldToTrackerAction(type),
    "Details",
  );

  return (
    <DebouncedTextInput
      className={
        type === "vehicleRegNo"
          ? "t_vehicle_reg_details_edit"
          : "t_trailer_reg_details_edit"
      }
      name={type}
      maskInput={formatRegistrationNumberString}
      maxLength={MAX_LENGTH_TRAILER_REG}
      disabled={disabled}
      editedValue={editedValue || ""}
      initialValue={initialValue || ""}
      onChange={onChange}
      onBlur={onBlur}
      onFocus={onFocus}
      buttonRight={icon}
      id={id}
    />
  );
};
